import { useState, useEffect } from 'react';
import { getTemplateString } from 'common/helpers/string';
import {
  parseRawNumber,
  formatNumber,
} from 'templates/IncomeAndExpendituresPageData/Utils/FormatNumbers';
import { formProgression } from 'common/helpers/Gtm';

interface Props {
  PageData?: any;
  Model?: any;
  currencyClass?: string;
  setDisableConfirmBtn?: any;
  IncomeAndExpenditureFormModel?: any;
  setIncomeAndExpenditureFormModel?: any;
}

const OtherDebtSummary = (props: Props) => {
  const {
    Model,
    PageData,
    currencyClass,
    setDisableConfirmBtn,
    IncomeAndExpenditureFormModel,
    setIncomeAndExpenditureFormModel,
  } = props;
  const [showAvailableIncomeLessWarning, setShowAvailableIncomeLessWarning] =
    useState<boolean>(false);
  const [
    showFoodExpenseLowerConfirmation,
    setShowFoodExpenseLowerConfirmation,
  ] = useState<boolean>(false);
  const [monthlyPaymentConfirmChecked, setMonthlyPaymentConfirmChecked] =
    useState<boolean>(false);
  const [
    enableMonthlyPaymentConfirmInput,
    setEnableMonthlyPaymentConfirmInput,
  ] = useState<boolean>(false);
  const monthlyPaymentOutOfRangeWarning = getTemplateString(
    PageData?.MonthlyPaymentOutOfRangeWarning,
  );
  const minimumPaymentAmount = getTemplateString(Model?.MinimumPaymentAmount);
  const maximumPaymentAmount = getTemplateString(Model?.MaximumPaymentAmount);

  let incomeExpenseFormValues = {
    ...IncomeAndExpenditureFormModel.MonthlyIncomeAndExpensesFormModel,
  };
  let otherDebtSummaryFormValues = {
    ...IncomeAndExpenditureFormModel.OtherDebtSummaryFormModel,
  };
  let otherDebtFormValues = {
    ...IncomeAndExpenditureFormModel?.OtherDebtFormModel,
  };

  const totalExpenditure =
    parseRawNumber(incomeExpenseFormValues.totalHouseholdExpenses, 2) +
    parseRawNumber(otherDebtFormValues.totalDebtPayments, 2);
  const availableIncome =
    parseRawNumber(incomeExpenseFormValues.totalHouseholdIncome, 2) -
    totalExpenditure;
  let monthlyPaymentConfirmInput =
    Model.RedirectFromPayerReview == true
      ? Model.PlanAgreedInstallmentAmount.replace('&euro;', '€')
      : Model.SelectedInstallmentAmount.replace('&euro;', '€');

  let monthlyPaymentConfirmInputInitialValue: number = parseRawNumber(
    monthlyPaymentConfirmInput,
    2,
  );
  let installmentAmount: string;

  let changeMonthlyPaymentConfirmInput = (e: any) => {
    const currentValue = parseRawNumber(e.target.value, 2),
      availableIncomeValue = parseRawNumber(
        formatNumber(availableIncome, ','),
        2,
      );

    monthlyPaymentConfirmInput = e.target.value;
    otherDebtSummaryFormValues['monthlyPaymentConfirmInput'] = e.target.value;
    setMonthlyPaymentConfirmChecked(false);
    setIncomeAndExpenditureFormModel({
      ...IncomeAndExpenditureFormModel,
      OtherDebtSummaryFormModel: otherDebtSummaryFormValues,
    });
    setMonthlyPaymentConfirmChecked(false);
    if (
      currentValue <
      parseRawNumber(formatNumber(Model?.MinimumPaymentAmount, ','), 2)
    ) {
      setShowAvailableIncomeLessWarning(true);
      if (currentValue > availableIncomeValue) {
        setShowFoodExpenseLowerConfirmation(true);
      } else {
        setShowFoodExpenseLowerConfirmation(false);
      }
      setDisableConfirmBtn(true);
    } else if (currentValue > availableIncomeValue) {
      setShowFoodExpenseLowerConfirmation(true);
      setShowAvailableIncomeLessWarning(false);
      setDisableConfirmBtn(true);
    }
    else {
      setShowAvailableIncomeLessWarning(false);
      setShowFoodExpenseLowerConfirmation(false);
      setDisableConfirmBtn(false);
    }
  };

  let changeMonthlyPaymentConfirmCheckBox = (e: any) => {

    let monthlyPaymentConfirmInputRawValue = parseRawNumber(
      otherDebtSummaryFormValues['monthlyPaymentConfirmInput'],
      2,
    );
    let monthlyPaymentConfirmInputToCompare = monthlyPaymentConfirmInputRawValue > 0 ? monthlyPaymentConfirmInputRawValue : monthlyPaymentConfirmInputInitialValue;

    if (e.target.checked == true) {
      setMonthlyPaymentConfirmChecked(true);
      if (
        Model.RedirectFromPayerReview === false &&
        (monthlyPaymentConfirmInputToCompare < parseRawNumber(formatNumber(Model?.MinimumPaymentAmount, ','), 2) ||
          monthlyPaymentConfirmInputToCompare > parseRawNumber(formatNumber(Model?.MaximumPaymentAmount, ','), 2))
      ) {
        setDisableConfirmBtn(true);
      } else {
        setDisableConfirmBtn(false);
      }
    } else {
      setDisableConfirmBtn(true);
      setMonthlyPaymentConfirmChecked(false);
    }
  };

  let clickUpdateAmount = () => {
    if (Model.RedirectFromPayerReview === true) {
      window.location = Model.UpdatePaymentPlanChangeAmountUrl;
    } else {
      setEnableMonthlyPaymentConfirmInput(true);
    }
  };
  useEffect(() => {
    if (
      (Model.RedirectFromPayerReview === false &&
        monthlyPaymentConfirmInputInitialValue <
        parseRawNumber(formatNumber(Model.MinimumPaymentAmount, ','), 2))
    ) {
      setShowAvailableIncomeLessWarning(true);
      setDisableConfirmBtn(true);
      setMonthlyPaymentConfirmChecked(false);
    } else {
      setShowAvailableIncomeLessWarning(false);
      setDisableConfirmBtn(false);
      setMonthlyPaymentConfirmChecked(false);
      setShowFoodExpenseLowerConfirmation(false);
    }
    if (Model.RedirectFromPayerReview === false) {
      installmentAmount = Model.SelectedInstallmentAmount;
    } else {
      installmentAmount = Model.PlanAgreedInstallmentAmount;
    }
    if (availableIncome < parseRawNumber(installmentAmount, 2)) {
      setDisableConfirmBtn(true);
      setShowFoodExpenseLowerConfirmation(true);
    }

  }, [availableIncome, Model]);
  return (
    <div className="OtherDebt__summary OtherDebt__summary--no-border">
      <div className="OtherDebt__summaryWrapper">
        <div className="OtherDebt__formRow">
          <div className="OtherDebt__inputsWrapper">
            <label className="IncomeAndExpenditure__label">
              <span className="IncomeAndExpenditure__labelText">
                {PageData?.TotalIncomeLabel}
              </span>
              <div
                className={
                  'Input Input-icon Input-icon--before ' +
                  currencyClass +
                  ' Input-textCenter'
                }
              >
                <input
                  type="text"
                  name="confirmationTotalIncome"
                  value={formatNumber(
                    parseRawNumber(
                      incomeExpenseFormValues.totalHouseholdIncome,
                      2,
                    ),
                    ',',
                  )}
                  className="non-editable"
                  readOnly
                  placeholder={PageData?.InputAmountPlaceHolderText}
                />
                <span></span>
              </div>
            </label>

            <label className="IncomeAndExpenditure__label">
              <span className="IncomeAndExpenditure__labelText">
                {PageData?.ExpenditureLabel}
              </span>
              <div
                className={
                  'Input Input-icon Input-icon--before ' +
                  currencyClass +
                  ' Input-textCenter'
                }
              >
                <input
                  type="text"
                  name="confirmationTotalExpenditure"
                  value={formatNumber(totalExpenditure, ',')}
                  className="non-editable"
                  readOnly
                  placeholder={PageData?.InputAmountPlaceHolderText}
                />
                <span></span>
              </div>
            </label>

            <label className="IncomeAndExpenditure__label">
              <span className="IncomeAndExpenditure__labelText">
                {PageData?.AvailableIncomeLabel}
              </span>
              <div
                className={
                  'Input Input-icon Input-icon--before ' +
                  currencyClass +
                  ' Input-textCenter'
                }
              >
                <input
                  type="text"
                  name="confirmationAvalibleIncome"
                  value={formatNumber(availableIncome, ',')}
                  className="non-editable"
                  readOnly
                  placeholder={PageData?.InputAmountPlaceHolderText}
                />
                <span></span>
              </div>
              <span className="IncomeAndExpenditure__labelInfo">
                {PageData?.AvailableIncomeNote}
              </span>
            </label>
          </div>
          <div
            className={
              'IncomeAndExpenditure__monthlyPayment ' +
              (showAvailableIncomeLessWarning || showFoodExpenseLowerConfirmation
                ? 'IncomeAndExpenditure__monthlyPayment--warning'
                : '')
            }
            id="monthlyPaymentConfirmDiv"
          >
            <label className="IncomeAndExpenditure__label">
              <span className="IncomeAndExpenditure__labelText">
                {PageData?.MonthlyPaymentLabel}
              </span>
              <div
                className={
                  !enableMonthlyPaymentConfirmInput
                    ? ' Input Input Input-button--after Input--sand Input--no-border'
                    : 'Input Input Input-button--after'
                }
                id="monthlyPaymentInputDiv"
              >
                <div className={"Input Input-icon Input-icon--before " + currencyClass + " Input-textCenter"}>
                  <input
                    type="text"
                    name="monthlyPaymentConfirmInput"
                    className={
                      !enableMonthlyPaymentConfirmInput ? 'non-editable' : ''
                    }
                    value={
                      otherDebtSummaryFormValues['monthlyPaymentConfirmInput'] ||
                      monthlyPaymentConfirmInputInitialValue
                    }
                    readOnly={!enableMonthlyPaymentConfirmInput}
                    placeholder={PageData?.InputAmountPlaceHolderText}
                    onChange={(val) => changeMonthlyPaymentConfirmInput(val)}
                    onBlur={(e) => formProgression(e, 'I&E form', 'monthlyPayment')}
                  />
                  <span>

                  </span>
                </div>
                <span>
                  <button
                    id="updateAmountBtn"
                    className="Button Input-button"
                    onClick={clickUpdateAmount}
                  >
                    {PageData.ChangeAmountButtonLabel}
                  </button>
                </span>
              </div>
            </label>
            {showFoodExpenseLowerConfirmation && (
              <label
                id="foodExpenseLowerConfirmation"
                className="ConfirmationBox ConfirmationBox--noMargin"
              >
                <input
                  type="checkbox"
                  id="monthlyPaymentConfirmCheckBox"
                  className="ConfirmationBox__input"
                  checked={monthlyPaymentConfirmChecked}
                  defaultChecked={false}
                  onChange={(val) => changeMonthlyPaymentConfirmCheckBox(val)}
                />
                <span className="ConfirmationBox__box"></span>
                <p className="ConfirmationBox__text">
                  <span className="ConfirmationBox__warning ConfirmationBox__warning--orange ConfirmationBox__warning--inline">
                    {PageData?.YouHaveEnteredMoreAmountLabel}
                  </span>
                  {PageData?.PleaseConfirmYouWantToProceedLabel}
                </p>
              </label>
            )}
            {showAvailableIncomeLessWarning && (
              <span
                id="availableIncomeLessWarning"
                className="ConfirmationBox__warning"
                dangerouslySetInnerHTML={{
                  __html: monthlyPaymentOutOfRangeWarning
                    ? monthlyPaymentOutOfRangeWarning({
                      MinimumPaymentAmount: Model?.MinimumPaymentAmount
                    })
                    : '',
                }}
              ></span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default OtherDebtSummary;
